<p-splitter [panelSizes]="[50, 50]">
  <ng-template pTemplate>
    <div class="flex items-center justify-center h-full">FIRMA FLUJO</div>
  </ng-template>
  <ng-template pTemplate>
    <div class="flex items-center justify-center h-full">POSICIÓN</div>
  </ng-template>
</p-splitter>
<p-splitter [panelSizes]="[50, 50]" [style]="{ minHeight: '200px', maxHeight: '350px' }">
  <ng-template pTemplate>
    <p-splitter styleClass="h-full" layout="vertical" [panelSizes]="[50, 50]">
      <ng-template pTemplate>
        <p-listbox [options]="signService.getImagenesFirma()" [metaKeySelection]="false" optionLabel="nombre"
          [style]="{ border: 'none' }" class="w-full h-full" (onChange)="onFirmaChange($event)">
          <ng-template let-item pTemplate="item">
            <div class="tw-px-2 tw-py-0">{{ item.TipoFirma }}</div>
          </ng-template>
        </p-listbox>
      </ng-template>
      <ng-template pTemplate>
        @if(base64ImageSign()) {
          <img [src]="base64ImageSign()" alt="Firma por defecto" style="max-width: 200px;">
        }
      </ng-template>
    </p-splitter>
  </ng-template>
  <ng-template pTemplate>
    <p-listbox [options]="signService.getPosXY()" [metaKeySelection]="false" optionLabel="PosicionNombre"
      [style]="{ border: 'none' }" (onChange)="onPosicionChange($event)"
      class="w-full">
      <ng-template let-item pTemplate="item">
        <div class="tw-px-2 tw-py-0">{{item.PosicionNombre}}</div>
      </ng-template>
    </p-listbox>
  </ng-template>
</p-splitter>

<!-- Footer de acciones -->
<div class="flex flex-row-reverse gap-2 p-3">
  <p-button label="Insertar Firma" icon="pi pi-check" styleClass="p-button-danger" (onClick)="onSign()" [disabled]="onDisabledButtonsSign()"></p-button> 
  <p-button label="Vista Preliminar" icon="pi pi-eye" styleClass="p-button-primary" (onClick)="onPreview()" [disabled]="onDisabledButtonsSign()"></p-button>  
</div>

<p-confirmdialog styleClass="w-96 h-48"/>